import { render, staticRenderFns } from "./BlockDateCardBlock.vue?vue&type=template&id=510badbf&"
import script from "./BlockDateCardBlock.vue?vue&type=script&lang=js&"
export * from "./BlockDateCardBlock.vue?vue&type=script&lang=js&"
import style0 from "./BlockDateCardBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports